import styled from '@emotion/styled';
import { TextLink, Typography } from '@mgmresorts/mgm-ui';
import { core } from '@mgmresorts/vega-tokens';

import { Container } from '../../../components/ui/Container';
import { convertFontWeight } from '../../../utils/vegaTokenHelpers';

export const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 135%;
  gap: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const StyledHeading = styled(Typography)`
  ${({ theme }) => `
    color: ${theme.semantic.FgDefault};
    padding-top: ${theme.semantic.SpaceComponentL}px;
    margin-top: ${theme.semantic.SpaceComponentXl}px;
    margin-bottom: ${theme.semantic.SpaceComponentL}px;
    text-align: left;
    line-height:${theme.semantic.SpaceComponentNone}px;
    
    @media (max-width: 768px) {
      font-size: ${theme.semantic.HeadingMedium2?.fontSize || theme.core.FontsizeXl}px;
      margin-top: ${theme.semantic.SpaceComponentM}px;
      padding-top: ${theme.semantic.SpaceComponentM}px;
    }
  `}
`;

export const StyledLabel = styled(Typography)`
  ${({ theme }) => `
    color: ${theme.semantic.FgDefault};
    text-align: left;
    font-weight: ${convertFontWeight(core.Fontweight400)};
    line-height: 130%;
    
    
    @media (max-width: 768px) {
      margin-bottom: ${theme.semantic.SpaceComponentNone}px;
      width: fit-content;
    }
  `}
`;

export const StyledBody = styled(Typography)`
  ${({ theme }) => `
    color: ${theme.semantic.FgContrast};
    line-height: 1.5;
    text-align: left;
    
    @media (max-width: 768px) {
      margin-bottom: ${theme.semantic.SpaceComponentM}px;
    }
  `}
`;

export const StyledContactInfo = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${theme.semantic.SpaceComponentS}px;
    padding-bottom: ${theme.semantic.SpaceComponentL}px;
  `}
`;

export const StyledPhoneNumber = styled(Typography)`
  ${({ theme }) => `
    color: ${theme.semantic.FgDefault};
    font-weight: ${convertFontWeight(core.Fontweight600)};
    font-size: ${theme.semantic.BodyRegularL?.fontSize || theme.core.FontsizeL}px;
  `}
`;
export const StyledContainer = styled(Container)`
  position: relative !important;
  top: 0 !important;
  margin-top: 0px !important;
`;

export const StyledFooterContainer = styled.div<{ $isMobile?: boolean }>`
  ${({ theme }) => `
    padding: 0px 0px ${theme.semantic.SpaceComponentM}px !important;
    flex-shrink: 0 !important;
    width: 100%;
    margin-top: auto !important;
    position: sticky;
    bottom: 0;
    z-index: 1;
  `}
  ${({ $isMobile }) => !$isMobile && `text-align: center;`}
  ${({ $isMobile }) => $isMobile && `position: relative; bottom: auto;`}
 
  > * {
    padding: 0 16px !important;
  }
`;

export const StyledTextLink = styled(TextLink)`
  margin: ${({ theme }) => theme.semantic.SpaceComponentNone} !important;
`;
